import { render } from "./Footer.vue?vue&type=template&id=ddefd4c8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=ddefd4c8&scoped=true&lang=css"

import exportComponent from "/builds/qes-dev/qes-apps/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddefd4c8"]])

export default __exports__